module.exports = __webpack_public_path__ + "img/Gefahr_durch_Wassereinbruch.e42e8825.svg";